/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import React, { useRef } from 'react';
import Page from 'components/custom/template/Page';
import useManagePageLoading from 'hooks/custom/useManagePageLoading';
import apiEndpoints from 'constants/apiEndpoints';
import { useNavigate } from 'react-router-dom';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import employeeAttendanceColumn from './employeeAttendanceColumn';
import { Card } from 'react-bootstrap';
const attendanceData = [
  // {
  //   user_id: 'EMP001',
  //   user_img_upload: '',
  //   user_attendence_date: '4 Aug 2024',
  //   designation_name: 'Software Engineer',
  //   punch_in: '09:00 AM',
  //   lunch_break_in: '12:30 PM',
  //   lunch_break_out: '01:00 PM',
  //   casual_break_in: '03:30 PM',
  //   casual_break_out: '03:45 PM',
  //   punch_out: '06:00 PM',
  //   duration: '9h',
  //   status: 'Present', // Could be Present, Absent, or On Leave
  //   action: 'Review',
  //   user_type: 'Driver'
  // },
  // {
  //   user_id: 'EMP002',
  //   user_img_upload: '',
  //   user_attendence_date: '5 Aug 2024',
  //   designation_name: 'Software Engineer',
  //   punch_in: '09:15 AM',
  //   lunch_break_in: '01:00 PM',
  //   lunch_break_out: '01:30 PM',
  //   casual_break_in: '04:00 PM',
  //   casual_break_out: '04:15 PM',
  //   punch_out: '06:15 PM',
  //   duration: '8h 45m',
  //   status: 'Present',
  //   action: 'View',
  //   user_type: 'Trucker'
  // },
  // {
  //   user_id: 'EMP003',
  //   user_img_upload: '',
  //   user_attendence_date: '6 Aug 2024',
  //   designation_name: 'Software Engineer',
  //   punch_in: '10:00 AM',
  //   lunch_break_in: '01:00 PM',
  //   lunch_break_out: '01:45 PM',
  //   casual_break_in: '04:30 PM',
  //   casual_break_out: '04:45 PM',
  //   punch_out: '07:00 PM',
  //   duration: '9h',
  //   status: 'Present',
  //   action: 'View',
  //   user_type: 'Developer'
  // },
  // {
  //   user_id: 'EMP004',
  //   user_img_upload: '',
  //   user_attendence_date: '7 Aug 2024',
  //   designation_name: 'Software Engineer',
  //   punch_in: '08:45 AM',
  //   lunch_break_in: '12:00 PM',
  //   lunch_break_out: '12:30 PM',
  //   casual_break_in: '03:00 PM',
  //   casual_break_out: '03:15 PM',
  //   punch_out: '05:45 PM',
  //   duration: '9h',
  //   status: 'Present',
  //   action: 'Review',
  //   user_type: 'Engineer'
  // },
  // {
  //   user_id: 'EMP005',
  //   user_img_upload: '',
  //   user_attendence_date: '8 Aug 2024',
  //   designation_name: 'Software Engineer',
  //   punch_in: '', // No punch in, status: Absent
  //   lunch_break_in: '',
  //   lunch_break_out: '',
  //   casual_break_in: '',
  //   casual_break_out: '',
  //   punch_out: '',
  //   duration: '0h',
  //   status: 'Absent',
  //   action: '',
  //   user_type: 'Hr'
  // }
];

const EmployeeAttendanceListDetails = ({ employeeId }) => {
  console.log('🚀 ~ EmployeeAttendanceListDetails ~ employeeId:', employeeId);
  const [pageLoading, loadingMessage, handleLoading] = useManagePageLoading();

  const refreshDataRef = useRef(null);
  const handleRefreshDataRegister = refreshData => {
    refreshDataRef.current = refreshData;
  };

  return (
    <Card>
      <Card.Body className="pt-0 pb-1 overflow-hidden">
        <Page
          tableColumn={{
            column: employeeAttendanceColumn({}),
            actions: false
          }}
          pageHeader={<h4 className="mb-4">Attendance List</h4>}
          pageHeaderProps={{ className: 'pt-4 position-relative px-3 px-lg-5' }}
          containerClassName={'mx-n4 mx-lg-n6'}
          searching={false}
          showTools={false}
          // dummyData={attendanceData}
          urlEndPoint={apiEndpoints.attendance.getEmployeeAttendance(
            employeeId
          )}
          exportName="attendence list"
          backdrop={{ message: loadingMessage, loading: pageLoading }}
          onRegisterRefresh={handleRefreshDataRegister}
          dataWithDateRange={false}
          dataFormatter={data => data.toReversed()}
        ></Page>
      </Card.Body>
    </Card>
  );
};

export default EmployeeAttendanceListDetails;
